import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './_admin';

// Code splitting: Lazy load DashboardPage to reduce initial bundle size
const DashboardPage = lazy(() => import('@/pages/admin/DashboardPage'));

/**
 * Admin dashboard route - /admin
 * Shows overview statistics and metrics
 */
export const adminIndexRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/',
  component: DashboardPage,
});

// Backward compatibility
export const Route = adminIndexRoute;
